import type { TipPreset } from "./TerminalSettingsTab";

/**
 * Preset slots Poynt's customer-facing tip prompt renders. It fills any slot
 * the terminal leaves unset with its own value — $0 in amount mode, a
 * chargeable 18% and 20% in percent mode — so all of them should be declared.
 */
export const SECOND_SCREEN_PRESET_COUNT = 3;

/**
 * Message warning that a preset list will not render as configured on a
 * terminal with a customer display, or null when there is nothing to say.
 *
 * Advisory, never blocking: admin cannot tell which terminal reads the row, a
 * single-screen terminal renders any count, and the tip presets save in the
 * same batch as the tax, receipt and invoice fields.
 */
export function tipPresetCountWarning(
  presets: TipPreset[],
  { tipEnabled }: { tipEnabled: boolean },
): string | null {
  if (!tipEnabled) return null;
  if (presets.length === SECOND_SCREEN_PRESET_COUNT) return null;
  return `Saved, but terminals with a customer display show ${SECOND_SCREEN_PRESET_COUNT} tip options and fill any missing one themselves. Enter exactly ${SECOND_SCREEN_PRESET_COUNT} for those terminals.`;
}
